<template>
    <Button :icon="attrs.icon" @click="handleClick" v-if="isDisplay">
        {{attrs.title}}
    </Button>
</template>
<script>
    /**
     * 处理路由跳转的按钮
     */
    import CompEventMixin from '@/utils/compEvent.mixin'
    import CompDisplayMixin from '@/utils/compDisplay.mixin'
    export default {
        name: 'LyRouteButton',
        mixins: [CompEventMixin, CompDisplayMixin],
        props: {
            row: {
                type: Object,
                default: _ => new Object()
            },// 提供给tabel，用于绑定行数据
        },
        created () {
            // 获取account信息 2019-11-14 wxf
            if(this.attrs.mark == 'account') {
                this.$set(this.page, localStorage.getItem("account"))
            }
        },
        methods: {
            /**
             * 按钮点击的监听
             */
            handleClick () {
                if (this.attrs.route.length > 0) { // 进行路由的跳转
                    let path = this.attrs.route
                    // 有data字段说明是表格中传递过来的
                    if (this.attrs.hasOwnProperty('island') && this.attrs.island) {
                        //快捷登陆
                        if (this.row.hasOwnProperty(this.attrs.field)) { 
                            path += '?token=Bearer ' + this.row[this.attrs.field]
                        }
                        if (this.attrs.target) {
                            window.open(path, '_blank')
                        }
                    } else { 
                        if (this.row.hasOwnProperty('id')) {
                            path = this.$path.getPath(path, this.row)
                        } else {
                            let url = this.$path.getPath(path, this.page)
                            if (url.indexOf('undefined') > 0) {
                                path = this.$path.getPath(path, this.$route.params)
                            } else {
                                path = url
                            }
                        }
                        if (this.attrs.target) { // 新页面打开
                            let {href} = this.$router.resolve({path});
                            /**-------这里改为根据返回的参数直接跳转 start---------- */
                            let str = 'localhost'
                            let localIndex = href.indexOf(str)
                            if (localIndex >= 0) {
                                href = href.substring(localIndex + str.length + 1, href.length)
                            }
                            /**-------这里改为根据返回的参数直接跳转 end---------- */
                            window.open(href, '_blank');
                        } else {
                            this.$router.push({path})
                        }
                    }
                    
                } else { // 如果没有指定路由，跳转到上个页面
                    this.$router.go(-1)
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// ../projectCore/src/components/route-button/src/index.vue